import { html, ref } from '@microsoft/fast-element';
import { closeIcon } from '../../styles';
import type { CenteredModal } from './centered-modal';

export const CenteredModalTemplate = html<CenteredModal>`
  <fast-dialog
    class="centered-dialog"
    part="default-dialog"
    ${ref('centeredDialog')}
    modal="true"
    hidden
  >
    <div class="header" tabindex="-1">
      <slot name="header-start" part="header-start"></slot>
      <zero-button
        tabindex="-1"
        appearance="stealth"
        @click="${(x) => x.closeDialog()}"
        class="closing-icon"
      >
        ${closeIcon}
      </zero-button>
      ${(x) => x.header}
    </div>
    <slot></slot>
  </fast-dialog>
`;
